import Headroom from 'headroom.js';

const Menu = {
  headroom: function() {
    let headroom;

    let options = {
      // vertical offset in px before element is first unpinned
      offset: 0,
      // scroll tolerance in px before state changes
      tolerance: 0,
      // or you can specify tolerance individually for up/down scroll
      tolerance: {
        up: 5,
        down: 0,
      },
      // css classes to apply
      classes: {
        // when element is initialised
        initial: 'headroom--not-top',
        // when scrolling up
        pinned: 'headroom--pinned',
        // when scrolling down
        unpinned: 'headroom--unpinned',
        // when above offset
        top: 'headroom--not-top',
        // when below offset
        notTop: 'headroom--not-top',
        // when at bottom of scoll area
        bottom: 'headroom--bottom',
        // when not at bottom of scroll area
        notBottom: 'headroom--not-bottom',
        // when frozen method has been called
        frozen: 'headroom--frozen',
      },
      // element to listen to scroll events on, defaults to `window`
      // scroller : someElement,
      // callback when pinned, `this` is headroom object
      onPin: function() {
        $('.hero-navigation').addClass('large');
        $('.homepage-navigation').addClass('large');
        $('.nav-dropdowns-wrapper ').addClass('large');
      },
      // callback when unpinned, `this` is headroom object
      onUnpin: function() {
        $('.hero-navigation').addClass('fixed');
        $('.hero-navigation').removeClass('large');
        $('.homepage-navigation').addClass('fixed');
        $('.homepage-navigation').removeClass('large');
        $('.nav-dropdowns-wrapper ').removeClass('large');
      },
      // callback when above offset, `this` is headroom object
      onTop: function() {
        $('.hero-navigation').removeClass('fixed');
        $('.homepage-navigation').removeClass('fixed');
      },
      // callback when below offset, `this` is headroom object
      onNotTop: function() {},
      // callback when at bottom of page, `this` is headroom object
      onBottom: function() {},
      // callback when moving away from bottom of page, `this` is headroom object
      onNotBottom: function() {},
    };

    let optionsShop = {
      // vertical offset in px before element is first unpinned
      offset: 0,
      // scroll tolerance in px before state changes
      tolerance: 0,
      // or you can specify tolerance individually for up/down scroll
      tolerance: {
        up: 5,
        down: 0,
      },
      // css classes to apply
      classes: {
        // when element is initialised
        initial: 'headroom',
        // when scrolling up
        pinned: 'headroom--pinned',
        // when scrolling down
        unpinned: 'headroom--unpinned',
        // when above offset
        top: 'headroom--top',
        // when below offset
        notTop: 'headroom--not-top',
        // when at bottom of scoll area
        bottom: 'headroom--bottom',
        // when not at bottom of scroll area
        notBottom: 'headroom--not-bottom',
        // when frozen method has been called
        frozen: 'headroom--frozen',
      },
      // element to listen to scroll events on, defaults to `window`
      // scroller : someElement,
      // callback when pinned, `this` is headroom object
      onPin: function() {
        $('.hero-navigation').addClass('large');
        $('.nav-dropdowns-wrapper ').addClass('large');
      },
      // callback when unpinned, `this` is headroom object
      onUnpin: function() {
        $('.hero-navigation').addClass('fixed');
        $('.hero-navigation').removeClass('large');
        $('.nav-dropdowns-wrapper ').removeClass('large');
      },
      // callback when above offset, `this` is headroom object
      onTop: function() {
        $('.hero-navigation').removeClass('fixed');
      },
      // callback when below offset, `this` is headroom object
      onNotTop: function() {},
      // callback when at bottom of page, `this` is headroom object
      onBottom: function() {},
      // callback when moving away from bottom of page, `this` is headroom object
      onNotBottom: function() {},
    };

    // construct an instance of Headroom, passing the element

    if (document.contains(document.querySelector('.footer.shop-baileyana'))) {
      //for ShopAll site disable pinned header
      let myElement;

      if (document.contains(document.querySelector('.hero-navigation'))) {
        myElement = document.querySelector('.hero-navigation');
      } else {
        myElement = document.querySelector('.header');
      }

      headroom = new Headroom(myElement, optionsShop);

      document.querySelector('.header').classList.add('shopAll');

      if (document.contains(document.querySelector('.hero-image'))) {
        //override and make light when hero image
        $('.header-button a .button img.light').css('display', 'none');
        $('.header-button a .button img.dark').css('display', 'block');
        $('.header .header-nav .header-section:nth-child(3) .header-button a .button').css('border', '0.5px solid rgba(255, 255, 255, 0.3)');
      }
    } else {
      const myElement = document.querySelector('.header');
      headroom = new Headroom(myElement, options);
    }

    // initialise
    headroom.init();
  },
  init: function() {
    this.headroom();
  },
};

export default Menu;
